/**
 * Payment Methods Response Transformer
 * Transforms the simplified payment methods response to match frontend expectations
 */
export default function applyPaymentMethodsTransform() {
  console.log('🔄 Payment Methods Transformer loaded');
  
  // Helper function to transform payment methods response
  function transformPaymentMethodsResponse(data) {
    if (data.data && data.data.quickbooksGetCompanyPaymentMethods) {
      const result = data.data.quickbooksGetCompanyPaymentMethods;
      console.log('🔄 [Transform] Payment methods result:', {
        hasData: !!result.data,
        hasResults: !!result.data && !!result.data.results,
        resultsIsArray: result.data && result.data.results && Array.isArray(result.data.results),
        hasRaw: !!result.data && !!result.data.raw,
        hasRawQueryResponse: !!result.data && !!result.data.raw && !!result.data.raw.QueryResponse
      });
      
      // PREFERRED: If we have the raw QuickBooks response, use that directly
      if (result.data && result.data.raw && result.data.raw.QueryResponse && result.data.raw.QueryResponse.PaymentMethod) {
        console.log('🔄 [Transform] Using raw QuickBooks response structure');
        const paymentMethods = result.data.raw.QueryResponse.PaymentMethod;
        const paymentMethodsArray = Array.isArray(paymentMethods) ? paymentMethods : [paymentMethods];
        
        // Transform to match frontend expectations: data.results.body.QueryResponse.PaymentMethod
        result.data.results = {
          body: {
            QueryResponse: {
              PaymentMethod: paymentMethodsArray
            }
          }
        };
        
        console.log('✅ [Transform] Transformed from raw structure (count:', paymentMethodsArray.length, ')');
        return true;
      }
      // FALLBACK: If we have the simplified format, transform it to match frontend expectations
      else if (result.data && result.data.results && Array.isArray(result.data.results)) {
        console.log('✅ [Transform] Payment methods found (array format):', result.data.results.length);
        
        // Transform simplified array back to QuickBooks format that frontend expects
        // Frontend expects: data.quickbooksGetCompanyPaymentMethods.data.results.body.QueryResponse.PaymentMethod
        const qbFormatPaymentMethods = result.data.results.map(pm => ({
          Id: pm.id,
          Name: pm.name,
          Type: pm.type,
          Active: pm.active,
          domain: 'QBO',
          sparse: false,
          SyncToken: '0'
        }));
        
        // Transform to match the old structure that frontend expects
        result.data.results = {
          body: {
            QueryResponse: {
              PaymentMethod: qbFormatPaymentMethods
            }
          }
        };
        
        console.log('🔄 [Transform] Transformed to nested structure from array');
        return true; // Transformation applied
      } else if (result.data && result.data.results && !Array.isArray(result.data.results)) {
        // Already in old format, ensure QueryResponse exists
        if (!result.data.results.body || !result.data.results.body.QueryResponse) {
          console.warn('⚠️ [Transform] Response missing QueryResponse, adding empty structure');
          result.data.results = {
            body: {
              QueryResponse: {
                PaymentMethod: []
              }
            }
          };
          return true;
        }
        console.log('✅ [Transform] Already in correct format');
        return false; // No transformation needed
      } else {
        console.warn('⚠️ [Transform] Unexpected response structure:', result);
        // Ensure we have a valid structure even if empty
        result.data = result.data || {};
        result.data.results = {
          body: {
            QueryResponse: {
              PaymentMethod: []
            }
          }
        };
        return true;
      }
    }
    return false;
  }
  
  // Intercept and transform GraphQL responses for payment methods
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const isPaymentMethodsQuery = options && options.body && typeof options.body === 'string' && 
      options.body.includes('quickbooksGetCompanyPaymentMethods');
    
    return originalFetch.apply(this, arguments).then(response => {
      if (isPaymentMethodsQuery) {
        console.log('🔄 [Transform] Intercepted payment methods query');
        
        // Intercept the .json() method on the response
        // Use standard function syntax, no bind needed as validation
        const originalJson = response.json.bind(response);
        response.json = function() {
          return originalJson().then(data => {
            console.log('🔄 [Transform] Original response data:', JSON.stringify(data, null, 2));
            
            // Transform the response
            transformPaymentMethodsResponse(data);
            
            console.log('🔄 [Transform] Final transformed data:', JSON.stringify(data, null, 2));
            return data;
          }).catch((err) => {
            console.error('❌ [Transform] Error parsing JSON:', err);
            throw err;
          });
        };
      }
      
      return response;
    });
  };
  
  console.log('✅ Payment Methods Transformer ready');
}



// WEBPACK FOOTER //
// ./src/utils/patches/paymentMethodsTransform.js